/* ==========================================================================
   LEON - Cross-Selling im Cart Drawer
   Gehoert zu: snippets/leon-cart-crosssell.liquid, sections/side-cart.liquid
   Eingebunden in layout/theme.liquid mit defer.

   Warum ein delegierter Listener auf document?
   Der Drawer wird bei jeder Warenkorb-Aenderung per innerHTML komplett
   ausgetauscht. Ein Listener am Button waere danach weg, ein Script im
   Drawer wuerde nie ausgefuehrt. Der Listener hier ueberlebt jeden Austausch.

   Ablauf beim Klick:
     1. POST /cart/add.js
     2. ajaxCart.load(false, true, false, true)
        forceRefetch: holt side-cart neu vom Server und tauscht den Drawer.
        Das Theme ruft dabei selbst updateCartCount() auf (Header-Zaehler).
        Das Cross-Selling rendert neu und schliesst den soeben hinzugefuegten
        Artikel aus (Filter "liegt schon im Warenkorb").
   ========================================================================== */
(function () {
  'use strict';

  if (window.__leonCartXS) return;
  window.__leonCartXS = true;

  var WURZEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STANDARD_FEHLER = 'Konnte nicht hinzugefügt werden. Bitte erneut versuchen.';

  function fehlertext(btn) {
    var host = btn.closest('.lxs');
    var t = host && host.getAttribute('data-lxs-fehler');
    return t || STANDARD_FEHLER;
  }

  function melde(btn, text) {
    var zeile = btn.closest('.lxs__zeile');
    if (!zeile) return;
    var alt = zeile.querySelector('.lxs__fehler');
    if (alt) alt.remove();
    var p = document.createElement('p');
    p.className = 'lxs__fehler';
    p.setAttribute('role', 'status');
    p.textContent = text;
    zeile.appendChild(p);
  }

  function neuLaden() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      try {
        window.ajaxCart.load(false, true, false, true);
        return;
      } catch (e) {
        /* faellt unten durch */
      }
    }
    window.location.reload();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.lxs__add') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.lxsBusy === '1') return;

    var vid = parseInt(btn.dataset.lxsVid, 10);
    if (!vid) return;

    btn.dataset.lxsBusy = '1';
    btn.classList.add('is-busy');

    fetch(WURZEL.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, daten: d };
        });
      })
      .then(function (res) {
        if (!res.ok || res.daten.status) {
          throw new Error(res.daten.description || res.daten.message || fehlertext(btn));
        }
        btn.classList.remove('is-busy');
        btn.classList.add('is-ok');
        setTimeout(neuLaden, 350);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.dataset.lxsBusy = '';
        melde(btn, (err && err.message) || fehlertext(btn));
      });
  });
})();
